import $ from 'jquery';
import { onLoad } from 'runtime';

onLoad(context => {
    // Featured Pages - Grab scroll
    const container = context.querySelector('.featured-pages');

    if (container) { // Check if the element exists
        let isDragging = false;
        let startX;
        let scrollLeft;

        // When the user starts dragging
        container.addEventListener('mousedown', (e) => { 
            isDragging = true;
            container.classList.add('active');
            startX = e.pageX - container.offsetLeft;
            scrollLeft = container.scrollLeft;
            e.preventDefault(); // Prevent text selection
        });

        // When the user stops dragging
        container.addEventListener('mouseup', () => {
            isDragging = false;
            container.classList.remove('active');
        });

        // If the user moves the mouse outside the container while dragging
        container.addEventListener('mouseleave', () => {
            isDragging = false;
            container.classList.remove('active');
        });

        // When the user moves the mouse
        container.addEventListener('mousemove', (e) => {
            if (!isDragging) return; // Only run when actively dragging
            e.preventDefault(); // Prevent default actions (like text selection)
            const x = e.pageX - container.offsetLeft;
            const walk = (x - startX); // Adjust scroll speed if needed
            container.scrollLeft = scrollLeft - walk;
        });
    }
});